export const safeParseJSON = (json: string, defaultValue: any = null) => {
  try {
    return JSON.parse(json);
  } catch (error) {
    return defaultValue;
  }
};
